import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

const fieldDayAPI = axios.create({
  baseURL: `${API_BASE_URL}/field-day`,
  timeout: Number(process.env.REACT_APP_API_TIMEOUT) || 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Agregar token de autenticación cuando esté disponible (para reservas)
fieldDayAPI.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export const fieldDayService = {
  // Contenido de la página
  getConfig: async () => {
    const response = await fieldDayAPI.get('/config');
    return response.data;
  },

  // Días habilitados (con cupo restante)
  getDates: async (from, to) => {
    const params = {};
    if (from) params.from = from;
    if (to) params.to = to;
    const response = await fieldDayAPI.get('/dates', { params });
    return response.data;
  },

  // Disponibilidad de una fecha puntual
  getAvailability: async (date) => {
    const response = await fieldDayAPI.get('/availability', { params: { date } });
    return response.data;
  },

  // Calcular precio total
  calculatePrice: async (fieldDayDateId, adults, children = 0) => {
    const response = await fieldDayAPI.post('/calculate-price', {
      fieldDayDateId,
      adults,
      children,
    });
    return response.data;
  },

  // Crear reserva (requiere login)
  createReservation: async (data) => {
    const response = await fieldDayAPI.post('/reservations', data);
    return response.data;
  },

  // Mis reservas
  getMyReservations: async () => {
    const response = await fieldDayAPI.get('/reservations/me');
    return response.data;
  },

  // Una reserva por id
  getReservation: async (id) => {
    const response = await fieldDayAPI.get(`/reservations/${id}`);
    return response.data;
  },

  // Actualizar reserva (subir comprobante)
  updateReservation: async (id, data) => {
    const response = await fieldDayAPI.patch(`/reservations/${id}`, data);
    return response.data;
  },
};

export default fieldDayService;
